import React, { useState } from 'react'
import imgVideo from '../../../assets/img/69-video-content-ta-dah.gif'
import videoImg from '../../../assets/img/5884-video-movie.gif'
import defaultImg from '../../../assets/img/5856-image-picture.gif'
import Loading from '../../tools/Loading'
import { useDispatch } from 'react-redux'
import { useForm } from '../../../hooks/ useForm'
import { setSeccionVideo, setSeccionTitle, setSeccionPicture, setSeccionDescripcion, setSeccionLink } from '../../../helpers/contenido'
import { SECCCION_TRES } from '../../../directories/collections'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReactHtmlParser from 'react-html-parser'
import { setseccion3Description, setseccion3Enlace, setseccion3Imagen, setseccion3Titulo, setseccion3Video } from '../../../reducer/ContenidoReducer'
const SeccionTres = ({data, email, idAsig, idTema}) => {
    const dispatch = useDispatch();
    const {title,video, picture, link, description, id} = data;
    const [value, handleInputChange] = useForm({
        upTitle: title, upVideo: video, upImagen: picture, upEnlace: link
    });
    const [upDescripcion, setUpDescripcion] = useState(description)
    const {upTitle, upVideo, upImagen, upEnlace} = value
    const [edit, setEdit] = useState(false)
    const [loadingTitle, setLoadingTitle] = useState(false)
    const [loadingVideo, setLoadingVideo] = useState(false)
    const [loadingImagen, setLoadingImagen] = useState(false)
    const [loadingDescripcion, setLoadingDescripcion] = useState(false)
    const [loadingEnlace, setLoadingEnlace] = useState(false)

    
    const handleUpTitle = () => {
        setLoadingTitle(true)
        setSeccionTitle(email,idAsig,idTema,SECCCION_TRES,id,upTitle)
        .then(() => {
            dispatch(setseccion3Titulo(upTitle))
            setLoadingTitle(false)
        })
    }

    const handleUpVideo = () => {
        setLoadingVideo(true)
        setSeccionVideo(email,idAsig,idTema,SECCCION_TRES,id,upVideo)
        .then(() => {
            dispatch(setseccion3Video(upVideo))
            setLoadingVideo(false)
        })
    }

    const handleUpImagen = () => {
        setLoadingImagen(true)
        setSeccionPicture(email,idAsig,idTema,SECCCION_TRES,id,upImagen)
        .then(() => {
            dispatch(setseccion3Imagen(URL.createObjectURL(upImagen)))
            setLoadingImagen(false)
        })
    }

    const handleUpDescripcion = () => {
        setLoadingDescripcion(true)
        setSeccionDescripcion(email,idAsig,idTema,SECCCION_TRES,id,upDescripcion)
        .then(() => {
            dispatch(setseccion3Description(upDescripcion))
            setLoadingDescripcion(false)
        })
    }

    const handleUpEnlace = () => {
        setLoadingEnlace(true)
        setSeccionLink(email,idAsig,idTema,SECCCION_TRES,id,upEnlace)
        .then(() => {
            dispatch(setseccion3Enlace(upEnlace))
            setLoadingEnlace(false)
        })
    }
    return (
        <div className='sec3'>
            <div className='title_sec'>
                {
                    edit
                    ? <div className='form_up_title_sec'>
                        <input type='text' name='upTitle' value={upTitle} onChange={handleInputChange} />
                        {
                            loadingTitle
                            ? <Loading />
                            :<i className='fas fa-save'
                                onClick={handleUpTitle}
                            ></i>
                        }
                        </div>
                    :<h1 className='cont_txt_title'>{title}</h1>
                }
            </div>
            
            <div className='video'>
                {
                    video === ''
                    ? <img src={imgVideo} alt='imagen Video' />
                    :<a href={video} target='_blank' rel='noreferrer'><img src={videoImg} alt='imagen Video' /></a>
                }
                {
                    edit
                    &&   
                        <div className='bts_controls_contenido'>
                            <input type='url' 
                                value={upVideo} onChange={handleInputChange} 
                                name='upVideo' placeholder='Enlace Video'
                            />
                            {
                                loadingVideo
                                ? <Loading />
                                :<i className='fas fa-save' onClick={handleUpVideo}></i>
                            }
                            
                        </div>
                }
            </div>
            <div className='imagen'>
                {
                    picture === ''
                    ?<img src={defaultImg} alt='Imagen' />
                    :<img src={picture} alt='Imagen' />
                }
                {
                    edit
                    &&
                    <div className='bts_controls_contenido'>
                        
                        {
                            loadingImagen
                            ? <Loading />
                            :   <>
                                    <label htmlFor='up_img_sec1' className='fas fa-upload'> </label>
                                    <input type="file" id='up_img_sec1' name='upImagen' style={{display:'none'}}
                                        onChange={handleInputChange} />
                                    <i className='fas fa-save' onClick={handleUpImagen} ></i>
                                </>
                        }
                        
                    </div>
                }
            </div>
            <div className='descripcion'>
                {
                    edit
                    ?   
                        <>
                            <CKEditor key='ckEd_s1'  
                                editor={ClassicEditor} 
                                data={upDescripcion}
                                onChange={(e,editor) => setUpDescripcion(editor.getData())}
                            />

                            {
                                loadingDescripcion
                                ? <Loading />
                                :<button 
                                    className='btn_success'
                                    onClick={handleUpDescripcion}
                                >Guardar</button>
                            }
                        </>
                    : <article>{ReactHtmlParser(description)}</article>
                }
            </div>
            
            <div className='enlace'>
                {
                    edit
                    ?
                        <div className='bts_controls_contenido'>
                            <input type='url' 
                                value={upEnlace} onChange={handleInputChange} 
                                name='upEnlace' placeholder='Enlace Video'
                            />
                            {
                                loadingEnlace
                                ? <Loading />
                                :<i className='fas fa-save' onClick={handleUpEnlace}></i>
                            }
                            
                        </div>
                    :<div className='enlace_link'><a href={link}>enlace</a></div>
                }
            </div>
            <div className='bts_controls_contenido'>
                {
                    edit
                    ?<button className='btn_danger' onClick={() => setEdit(!edit)}>Salir de la edición</button>
                    :<button className='btn_info'  onClick={() => setEdit(!edit)}>Editar</button>
                }
            </div>
        </div>
    )
}

export default SeccionTres
